import axios, { AxiosError } from 'axios'
import { ProductsServiceInterface } from './productsService.interface'
import { ProductTypes } from '../../interfaces/products'
import exception from '../../utils/exception'
import { ServerError } from '../../interfaces/api'
import axiosInstance from '../axiosInstance'

class ProductsService implements ProductsServiceInterface {
  public async getProducts(): Promise<ProductTypes[] | null> {
    try {
      const response = await axiosInstance.get('/products/product/')
      return response.data.data as ProductTypes[]
    } catch (error) {
      if (axios.isAxiosError(error)) {
        exception(error as AxiosError<ServerError>)
      }
    }
    return null
  }
}

export default ProductsService
